export const CLIPBOARD_KIND = 'qa-path/automation-steps';
export const CLIPBOARD_VERSION = 1;

export const TOASTS = {
  COPY_OK: (n) => `${n} step${n === 1 ? '' : 's'} copied`,
  COPY_ONLY_CUSTOM: 'Only custom steps can be copied',
  COPY_ACCESS_BLOCKED: "Couldn't copy — clipboard access blocked",
  PASTE_OK: (n) => `${n} step${n === 1 ? '' : 's'} pasted`,
  PASTE_OK_WITH_DEFAULT_INSTRUCTION: (n) => `Created default instruction · ${n} step${n === 1 ? '' : 's'} pasted`,
  PASTE_EMPTY_CLIPBOARD: 'No steps on clipboard',
  PASTE_UNRECOGNIZED: 'Clipboard contents not recognized as steps',
  PASTE_FUTURE_VERSION: 'Clipboard data is from a newer version — please refresh',
  PASTE_INVALID: "Couldn't paste — clipboard contents invalid",
  PASTE_ABOVE_NEEDS_ANCHOR: 'Select a step to paste above',
};
